import _ from "lodash";

/**
 * 產生符合密碼規則的隨機密碼
 * - 總長度：10 個字元
 * - 包含：2 個小寫字母、2 個大寫字母、4 個數字、2 個特殊符號（!#_@）
 * - 特殊符號不會出現在密碼的第一個和最後一個位置
 */
export default function generatePassword() {
  const charset1 = "abcdefghijklmnopqrstuvxyz";
  const charset2 = "ABCDEFGHIJKLMNOPQRSTUVXYZ";
  const charset3 = "0123456789";
  const charset4 = "!#_@";

  const lowercaseChars = _.sampleSize(charset1, 2);
  const uppercaseChars = _.sampleSize(charset2, 2);
  const numberChars = _.sampleSize(charset3, 4);

  // 特殊符號不放在頭尾，先把 0 與 9 留給一般字元
  const remainingIndexes = _.difference(_.range(10), [0, 9]);
  const randomIndexes = _.sampleSize(remainingIndexes, 6);
  const selectedIndexes = _.shuffle([0, 9, ...randomIndexes]);

  const passwordArray = new Array(10);
  const allChars = [...lowercaseChars, ...uppercaseChars, ...numberChars];
  selectedIndexes.forEach((index, i) => {
    passwordArray[index] = allChars[i];
  });

  const emptyIndexes = _.range(10).filter(
    (i) => passwordArray[i] === undefined
  );
  const specialChars = _.sampleSize(charset4, 2);
  specialChars.forEach((char, i) => {
    passwordArray[emptyIndexes[i]] = char;
  });

  return passwordArray.join("");
}
